import pug from 'javascripts/work_tags/templates/coauthor_tag_edit.jst.pug';
window.JST = window.JST || {};
window.JST['work_tags/templates/coauthor_tag_edit'] = pug;
